import Swiper from 'swiper';
import { Thumbs, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/thumbs';
import 'swiper/css/effect-fade';

export default function (element, data) {
    const thumbsSwiper = new Swiper(".swiper-nav", {
        modules: [Thumbs],
        direction: 'horizontal',
        loop: false,
        // slidesPerView: 3,
        slidesPerView: 'auto',
        spaceBetween: 10,
        speed: 300,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
            768: {
                direction: 'vertical',
                spaceBetween: 0,
            },
        },
    });

    const contentSwiper = new Swiper(".swiper-content", {
        modules: [Thumbs, EffectFade],
        slidesPerView: 1,
        allowTouchMove: false,
        loop: true,
        effect: 'fade',
        speed: 300,
        fadeEffect: {
            crossFade: true
        },
        thumbs: {
            swiper: thumbsSwiper,
        },
    });

    contentSwiper.on('slideChange', () => {
        document.querySelectorAll('.video').forEach(v => {
            v.pause();
            v.currentTime = 0;
        });

        const activeVideo = contentSwiper.slides[contentSwiper.activeIndex]
            ?.querySelector('video');

        activeVideo?.play();
    });
};